import md5 from 'md5';

let dndpDefault = {
    url: "",
    debug: {},
    directory: "",
    items: {},
    names: [],
    el: {
        cp: ".spoint",
        // cp: ".pm__point",
        action: ".pm__rut",
        reward: "#popup_reward",
        rewardmulti: "#popup-multi-award",
        inform: "#popup_inform",
        informContent: "#popup_inform .MS__content p",
        rewardImg: "#reward-img",
        rewardContainer: "#rewardContainer",
    },
    variable: {
        spinable: true,
        urlGet: "",
        urlSave: "",
        methodGet: "",
        methodSave: ""
    },
    callback: function () { },
};

var temp = -1;
var angleInDegrees = 0;
var angleObj = {
    angle: angleInDegrees
};
var ket_qua;

const dndPromotion = function (options) {
    let defaults = dndpDefault;
    var settings = $.extend(defaults, options);

    let _CheckSO = "";
    let Key128Bytesold = "";
    var DataKey128 = "";
    let cp = parseInt($(settings.el.cp).html());

    // ===== FAKE API (chỉ chạy khi debug.status === true) =====
    // Chưa có link API thật → tự sinh nước đi để chạy hiệu ứng offline.
    // Khi debug.status === false: KHÔNG dùng phần này, đi $.ajax POST thật như cũ.
    let fakePos = parseInt(settings.startPosition, 10) || 1; // giữ vị trí xuyên suốt các lượt
    const FAKE_KEY =
        "Key128Bytes=MM8K1EE62C3B7437FA26AFC7A17643FF4B06143E15C50009E68HB4LEXFGDFHA7XY9KXF22EWMJMLZ6H47YPLM4G96BB4RLGWM9DXKMHPGKTHHCT4X8GAGP66P8HK44";
    const boardLen = () => $("#Frame1 .board .cell").length || 16; // số ô bàn cờ
    const makeFakeOne = () => {
        const len = boardLen();
        const random = Math.floor(Math.random() * 6) + 1; // xúc xắc 1..6
        const r = Math.random();
        const back = r < 0.2 ? Math.floor(Math.random() * 2) + 1 : 0; // ~20% có lùi
        const forward = !back && r > 0.8 ? Math.floor(Math.random() * 2) + 1 : 0; // ~20% tiến thêm
        const cur = fakePos;
        let np = (((cur - 1 + random) % len) + len) % len;
        if (back) np = (((np - back) % len) + len) % len;
        if (forward) np = (np + forward) % len;
        np += 1; // về lại 1-based
        fakePos = np;
        // FAKE_KEY không decode ra quẻ hợp lệ -> debug tự chọn 1 quẻ có sẵn ảnh (A=1.png, E=5.png).
        const fakeAwardKeys = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P"];
        const awardKey = fakeAwardKeys[Math.floor(Math.random() * fakeAwardKeys.length)];
        return { data: FAKE_KEY, random: random, back: back, forward: forward, currentPosition: cur, newPosition: np, awardKey: awardKey };
    };
    const makeFakeData = (totalTurn) => {
        if (totalTurn === 1) return makeFakeOne();
        const arr = [];
        for (let i = 0; i < totalTurn; i++) arr.push(makeFakeOne());
        return arr;
    };

    const closeAllPopup = () => {
        $(".popup").removeClass("active");
    };

    const activePopup = (id) => {
        $(id).addClass("active");
    };

    const informError = (content) => {
        $(settings.el.informContent).html(content);
        activePopup(settings.el.inform);
    };

    const nameToSrc = (name) => {
        return `${settings.directory}/${name}.${settings.items.type}`;
    };

    const getAwardID = (code) => {
        return settings.items[code];
    };

    const rewardPopupByType = {
        daicat: "#popup_reward",
        trungcat: "#popup_reward_trungcat",
        tieucat: "#popup_reward_tieucat",
    };

    const getGiftTypeConfig = () => {
        if (typeof giftType !== "undefined") return giftType;
        if (typeof window !== "undefined" && window.giftType) return window.giftType;
        if (typeof global !== "undefined" && global.giftType) return global.giftType;
        return {};
    };

    const getRewardPopup = (awardKey) => {
        const types = getGiftTypeConfig();
        for (var type in types) {
            if (types[type] && types[type].indexOf(awardKey) !== -1) {
                return rewardPopupByType[type] || settings.el.reward;
            }
        }
        return settings.el.reward;
    };

    const makePrize = (response) => {
        const {data} = response;
        var Key128 = data.split("=");
        var _Data = Key128[1];
        DataKey128 += _Data;
        var index = parseInt(_Data.charAt(127));
        var count_start = _Data.substr(index + 39, 4);
        // AC = key quẻ, dài 1 ký tự (wordNumber=1, items key là 1 chữ cái). Debug truyền awardKey sẵn.
        var AC = response.awardKey || _Data.substr(index + 32, 1)
        var _Code = _Data.substr(index + 33, 6);
        var _Encry1 = _Data.substr(index, 32);
        var _Encry2 = md5(_Encry1 + _Data.substr(index + 32, 2));
        var random = response.random;
        var currentPosition = response.currentPosition;
        var newPosition = response.newPosition;
        var random = response.random;
        var forward = response.forward;
        var back = response.back;

        return {
            indexImg: getAwardID(AC),
            indexWord: AC, // key chữ cái quẻ -> tra tên trong names[lang][AC]
            _Encry1: _Encry1,
            _Encry2: _Encry2,
            _Data: _Data,
            data: "Key32Bytes1=" + _Encry1 + "&Key32Bytes2=" + _Encry2,
            random: random,
            forward: forward,
            back: back,
            currentPosition: currentPosition,
            newPosition: newPosition
        };
    };


    const handleData = ($this, responseData) => {
        // console.log(responseData);
        var listPrize = [];
        var data = [];

        var totalTurn = $this.hasClass("rut-1") ? 1 : 10;
        var type = $this.data("value");
        var $chest = $this.prev();
        var $item = $this.parent();

        if (totalTurn === 1) {
            var prize = makePrize(responseData);
            listPrize.push(prize);
            data = prize.data;
        } else if (totalTurn === 10) {
            for (var i = 0; i < responseData.length; i++) {
                var prize = makePrize(responseData[i]);
                listPrize.push(prize);
                data = prize.data;
            }
        }

        if (type != undefined) {
            // Handler khi save xong — dùng chung cho cả debug (fake) lẫn ajax thật.
            const onSaveSuccess = async function (data) {
                    // setTimeout(function() {
                    //     settings.apiSuccess(settings.config.countEnd,settings.config.end);

                    // }, settings.config.timeApi);
                    // console.log("API success");
                    // closeAllPopup();
                    Key128Bytesold = DataKey128;
                    if (data.status === 1 && data.data === "ok") {
                        if (listPrize.length > 0) {
                            const rewardPopup = getRewardPopup(listPrize[0].indexWord);
                            listPrize.rewardPopup = rewardPopup;
                            listPrize[0].rewardPopup = rewardPopup;
                            const $rewardContainer = listPrize.length === 1
                                ? $(rewardPopup).find("[id='rewardContainer']")
                                : $(settings.el.rewardContainer);
                            $rewardContainer.empty();
                            switch (listPrize.length) {
                                case 1:
                                case 5:
                                case 10:
                                    await settings.animResult(listPrize);

                                    if (settings.config.animationCircle) AnimationLucky(listPrize[0].indexImg, settings.items.length);
                                    for (var i = 0, len = listPrize.length; i < len; i++) {
                                        var indexName = listPrize[i].indexImg;
                                        global.reward = indexName;

                                        var imgUrl = nameToSrc(indexName);
                                        // Tên quẻ: names[lang][indexWord], lang = class đầu của body (vd "vn").
                                        var lang = ($("body").attr("class") || "").trim().split(/\s+/)[0];
                                        var prizeName = ((settings.names[lang] || {})[listPrize[i].indexWord]) || "";
                                        if (listPrize.length == 5 || listPrize.length == 10) {
                                            $rewardContainer.append(`
                                                <img src="${imgUrl}" >
                                            `);
                                        } else {
                                            // lượt đơn (rut-1): render ảnh quà vào #rewardContainer như thiencotraquan
                                            $rewardContainer.append(`
                                                <div class="item">
                                                    <img src="${imgUrl}">
                                                    <div class="item-name reward-name">${prizeName}</div>
                                                </div>
                                            `);
                                        }

                                    }
                                    if ($(".pm__usedPoint").length > 0) {
                                        var usedPoint = $(".pm__usedPoint").html();
                                        usedPoint = parseInt(usedPoint);
                                        usedPoint += totalTurn;
                                        $(".pm__usedPoint").html(usedPoint);
                                    }

                                    settings.callback();
                                    if (listPrize.length == 5 || listPrize.length == 10) {
                                        activePopup(settings.el.rewardmulti);
                                    } else {
                                        activePopup(rewardPopup);
                                    }

                                    $(settings.el.action).removeClass('off')
                                    // setTimeout(function () {
                                    //     // custom code
                                       
                                    // }, settings.config.timeWait);

                                    settings.variable.spinable = true;
                                    break;
                                default:
                                    closeAllPopup();
                                    informError("Error: Results not return in 1 or 5 type.");
                                    return false;
                            }

                            var totalTurn = $this.hasClass("rut-1") ? 1 : 10;
                            cp = totalTurn == 10 ? cp - 10 : cp - 1;
                            $(settings.el.cp).html(cp);
                        }
                    }
                    // LuckyDrawExchangeModule.fetchViewData();
            };

            if (settings.debug.status) {
                // FAKE: bỏ qua server, coi như save thành công ngay.
                onSaveSuccess({ status: 1, data: "ok" });
            } else {
                $.ajax({
                    type: settings.variable.methodSave,
                    url: settings.variable.urlSave,
                    dataType: "json",
                    data: {
                        action: "save_data",
                        data: data,
                        type: type,
                        totalTurn: totalTurn,
                    },
                    success: onSaveSuccess,
                    error: function (response) {
                        settings.variable.spinable = true;
                        alert(response.data);
                    },
                });
            }
        } else {
            closeAllPopup();
            settings.variable.spinable = true;
            informError("Error: Missing data-type.");
        }

        _CheckSO = Key128Bytesold;
        if (_CheckSO == DataKey128) {
            return false;
        }
    };

    const getData = ($this) => {
        let totalTurn = $this.hasClass("rut-1") ? 1 : 10;
        let type = $this.data("value");
        var action = $this.hasClass("rut-1") ? "get_data" : "get_data_10";
        if (type != undefined) {
            if (settings.debug.status) {
                // FAKE: tự sinh nước đi (random/back/forward/currentPosition/newPosition),
                // không gọi server → chạy được khi chưa có API thật.
                closeAllPopup();
                settings.variable.spinable = true;
                handleData($this, makeFakeData(totalTurn));
                return;
            }
            $.ajax({
                type: settings.variable.methodGet,
                url: settings.variable.urlGet,
                dataType: "json",
                data: {
                    action: action,
                    type: type,
                    totalTurn: totalTurn,
                },
                beforeSend: function () {
                    // settings.getApi(settings.config.countStart,settings.config.start);
                    // $(settings.el.action).addClass('off')
                    // console.log("Get API");
                },
                success: function (response) {
                    closeAllPopup();
                    settings.variable.spinable = true;

                    if (response.status === 1) {
                        handleData($this, response.data);
                    } else {
                        informError(response.data);
                    }
                },
                error: function (response) {
                    closeAllPopup();
                    settings.variable.spinable = true;
                    informError("Vui lòng kiểm tra lại kết nối mạng để tiếp tục");
                },
            });
        } else {
            closeAllPopup();
            settings.variable.spinable = true;
            informError("Error: Missing data-type.");
        }
    };


    const main = () => {
        $(settings.el.action).on("click", function (e) {
            $(settings.el.action).addClass('off')
            e.preventDefault();
            if (settings.variable.spinable) {

                closeAllPopup();
                settings.variable.spinable = false;
                angleObj.angle = 45;
                angleInDegrees = 15;
                let totalTurn = $(this).hasClass("rut-1") ? 1 : 10;
                // if (totalTurn == 5 && $(settings.el.cp).text() < 5) {
                //     settings.variable.spinable = true;
                //     informError("Bạn chưa đủ lượt để quay nhanh x5 hoặc đã hết lượt. Vui lòng kiểm tra lại.");
                // } else if (totalTurn == 1 && $(settings.el.cp).text() < 1) {
                //     settings.variable.spinable = true;
                //     informError(settings.text.lessCp);
                // } else {
                //     getData($(this));
                // }
                cp = parseInt($(settings.el.cp).html());
                if (cp >= 1 && totalTurn == 1 || cp >= 10 && totalTurn == 10) {
                    angleObj.angle = 45;
                    angleInDegrees = 15;
                    getData($(this));
                } else {
                    settings.variable.spinable = true;
                    $(settings.el.action).removeClass('off');
                    informError("Bạn đã hết lượt hoặc không đủ lượt quay.");
                }
            }
        });
    };

    if (settings.debug.status) {
        settings.variable.urlGet = settings.debug.getLinkTest;
        settings.variable.urlSave = settings.debug.saveLinkTest;
        settings.variable.methodGet = "GET";
        settings.variable.methodSave = "GET";
    } else {
        settings.variable.urlGet = settings.url;
        settings.variable.urlSave = settings.url;
        settings.variable.methodGet = "POST";
        settings.variable.methodSave = "POST";
    }

    main();
};
window.DnDRotate = {
    loop: function () {
        var that = this;
        that.drawRotated(angleObj.angle);
        if (angleObj.angle == temp) {
            TweenLite.ticker.removeEventListener("tick", that.loop, that, false, 1);
        }
        temp = angleObj.angle;
    },
    drawRotated: function (degrees) {
        $(".animation_vongquay").css("transform", "rotate(" + degrees + "deg)");
    },
    AnimationRotate: function (ketqua) {
        var that = this;
        TweenMax.to(angleObj, 5, {
            angle: ketqua,
            delay: 0,
            repeat: 0
        });
        setTimeout(function () {
            TweenLite.ticker.addEventListener("tick", that.loop, that, false, 1);

        }, 0);
    }
};
const AnimationLucky = function (indexImg, countItems) {
    // ket_qua = (indexImg * (360 / countItems)) + (360 * countItems);
    ket_qua = Math.floor(indexImg * (360 / countItems)) + 360 * 3;
    window.DnDRotate.AnimationRotate(ket_qua);
};
export default dndPromotion;
